import { IDirectory } from '@netfront/ekardo-content-library';
import { IMapMarker } from '@netfront/ui-library';

const getMarkers = (directories: IDirectory[]): IMapMarker[] => {
  if (!directories.length) {
    return [];
  }

  return directories.flatMap(({ address, description, title }): IMapMarker[] => {
    if (!address) {
      return [];
    }

    const { latitude, longitude } = address;

    if (!(latitude && longitude)) {
      return [];
    }

    return [
      {
        description,
        latitude,
        longitude,
        title,
      },
    ];
  });
};

export { getMarkers };
